import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: last
      });
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/biz-review-feedbacks?createdAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let bizReviewFeedbacks = [];
    obj.forEach(function(bizReviewFeedback) {
      bizReviewFeedbacks.push({
        id: bizReviewFeedback.id,
        customerId: bizReviewFeedback.customerId,
        message: bizReviewFeedback.message,
        createdAt: Date.parse(bizReviewFeedback.createdAt)
      });
    });
    if (bizReviewFeedbacks.length > 0) {
      store.dispatch("entities/bizReviewFeedbacks/insert", {
        data: bizReviewFeedbacks
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
